import React from "react";
import { Button } from "@/components/ui/button";
import { Download, Printer } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface PDFPrintDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDownload: () => void;
  onPrint: () => void;
  title?: string;
  description?: string;
}

export function PDFPrintDialog({
  open,
  onOpenChange,
  onDownload,
  onPrint,
  title = "PDF Generado",
  description = "¿Desea descargar o imprimir el PDF?"
}: PDFPrintDialogProps) {
  const handleDownload = () => {
    onDownload();
    onOpenChange(false);
  };

  const handlePrint = () => {
    onPrint();
    onOpenChange(false);
  };

  const handleBoth = () => {
    onDownload();
    // Small delay before printing to ensure download starts
    setTimeout(() => onPrint(), 100);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2 sm:gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button variant="outline" onClick={handleDownload} className="flex items-center gap-1">
            <Download className="h-4 w-4" />
            Descargar
          </Button>
          <Button variant="outline" onClick={handlePrint} className="flex items-center gap-1">
            <Printer className="h-4 w-4" />
            Imprimir
          </Button>
          <Button onClick={handleBoth} className="flex items-center gap-1 bg-blue-600 hover:bg-blue-700">
            <Download className="h-4 w-4" />
            <Printer className="h-4 w-4" />
            Ambos
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}